import styled from 'styled-components'
import { styledScrollbar } from 'components/Common/GlobalStyles'
import { breakpoint } from 'utils/consts/breakpoints'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin: 0;
  overflow: auto;
  max-height: calc(100vh - 160px);
  padding: 0 16px 0 0;

  ${styledScrollbar};
`

export const Header = styled.div`
  font: var(--typography-16-18-bold);
  color: #121432;
  margin-bottom: 24px;

  @media screen and ${breakpoint.m} {
    line-height: 24px;
  }
`

export const Description = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #717284;
  margin-top: 8px;
  margin-bottom: 16px;
`

export const Group = styled.div`
  margin-bottom: 0;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;

  @media screen and ${breakpoint.s} {
    display: none;
  }
`

export const MobileFooter = styled.div`
  display: none;

  @media screen and ${breakpoint.s} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;

    button {
      flex: 1;
      padding-left: 0;
      padding-right: 0;
    }

    button:first-child {
      margin-right: 16px;
    }
  }
`

export const Content = styled.div`
  padding: 32px 16px 32px 32px;
  background: #fff;
  box-shadow: 0 16px 64px -16px rgba(0, 0, 0, 0.7);
  border-radius: 16px;
  overflow: auto;
  max-height: calc(100vh - 160px);
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 672px;

  @media screen and ${breakpoint.l} {
    max-width: 424px;
  }
`

export const ModalWrapper = styled.div`
  z-index: 1;

  @media screen and ${breakpoint.s} {
    padding: 8px;
    box-sizing: border-box;
  }
`
